<template>
  <el-date-picker
    style="width: 200px;"
    size="small"
    v-model="data"
    :type="timeType"
    @change="handleChange"
    :value-format="timeFormat"
    v-bind="$attrs"
  >
  </el-date-picker>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Array]
    },
    timeType: {
      type: String,
      default: 'year'
    },
    timeFormat: {
      type: String,
      default: 'yyyy'
    }
  },
  data() {
    return {
      data: this.value
    }
  },
  watch: {
    value(val) {
      this.data = val
    }
  },
  methods: {
    handleChange(val) {
      if (!val) {
        return this.$emit('input', '')
      }
      this.$emit('input', val)
    }
  }
}
</script>
